<template>
<div id="card-details">
    <div id="card-img">
        <img id="img-pincipal" :src="foto == '' ? '../../../../../../../static/img/survey/sem-foto.png' : 'data:image/png;base64,' + foto ">
    </div>
    <div id="info">
        <p class="text-center">INFORMAÇÕES</p>
    </div>
    <div class="card-details-body mt-4 ml-3">
        <div class="empre">
            <div class="mb-4 flex" id="nameTower"> <i class="fas fa-building icon"></i>{{selectedComissao.empreendimento.nome}}</div>
        </div>
        <p class="label-details">Status</p>
        <p class="result-status" :style='statusColor'> {{statusText}}</p>
        <p class="label-details">Valor Total da Comissão</p>
        <p class="result-details">{{selectedComissao.valorTotalComissaoFormatado}}</p>
        <p class="label-details">Porcentagem de Comissão</p>
        <p class="result-details">{{selectedComissao.credenciada.percentualComissao}}%</p>
        <p class="label-details">Valor Mensal</p>
        <p class="result-details">{{selectedComissao.valorParcelaFormatada}}</p>
        <p class="label-details">Imobiliária</p>
        <p class="result-details">{{selectedComissao.credenciada.nome}}</p>
        <p class="label-details">Dia de Vencimento Escolhido</p>
        <p class="result-details">{{datapagamento == null ? 'N/D': datapagamento.vencimentoAtual}}</p>
        <p class="label-details">Nome do Cliente</p>
        <p class="result-details">{{selectedComissao.cliente.nome}}</p>
        <hr>
        <div id="footer-card-details" class="w-100">
            <div class="text-center"><i class="fas fa-building icon"></i> Apartamento {{selectedComissao.proposta.empreendimentoUnidade.unidade}} - {{selectedComissao.proposta.empreendimentoUnidade.grupo}}</div>
        </div>
    </div>
</div>
</template>

<script>
import PanelSales from './panelsales'
export default PanelSales
</script>

<style scoped>
.icon{
    padding: 5px
}
.empre {
    display: flex;
    width: 100%;
}
.result-status{
    display:table;
    padding:5px;
    padding-left: 20px;
    padding-right: 20px;
    font-size:15px;
    width: fit-content;
    color: white;
    border-radius: 16px;
    padding: 5px 20px;

}

#img-pincipal {
    width: 100%;
    height: fit-content;
    object-fit: cover;
}

#card-img{
    height: 100%;
    display: flex;
    justify-content: center;
}

#nameTower{
    font-size: 19px;
}
#card-details{
  display: grid;
  background: white;
  margin-bottom: 2%;
  height: 100%;
}
#card-img{
    height: 100%;
}
.tab-content{
    height: calc(100% - 37.9px);
}
.tabs {
    height: 100%;
}

.text-center{
    font-size: 15px;
}

#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}

@media (min-width: 800px ) and (max-width: 1400px) {
  #nameTower{
      color: #5a5a5a;
      font-size: 17px;
      font-weight: 700;
      line-height: 30px;
      font-family: Segoe UI;
  }
}

@media (min-width: 1401px ){
  #nameTower{
    color: #5a5a5a;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
}
.label-details{
    padding-bottom: 6px;
    font-size: 13px;
    color: #666;
    font-weight: 700;
    margin-bottom: 0;
}

.result-details{
    font-size: 15px;
    color: #2a2a2a;
}

.flex{
    display: flex;
}

#footer-card-details{
    display: flex;
    font-size: 16px;
    font-weight: bold;
    color: #4F4C4D;
    height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/panelsales/panelsales.vue